import { Workstream } from '@/api/rest/resources/types/workstreams';
import { useOrganizationWorkstream } from '@/hooks/useOrganizationWorkstream';
import { useWorkstreamId } from '@/pages/shared/home/hooks/useWorkstreamId';
import { getRoadmapFromWorkstream } from '@/pages/shared/home/utils/index';
import { useOrganizationRoadmapNodes } from '@/pages/shared/hooks/useOrganizationRoadmapNodes';
import { assertIsDefined } from '@/utils/assert';

export const useWorkstreamMilestoneSteps = (workstreamIdArg?: string): Workstream => {
  const workstreamIdQueryParam = useWorkstreamId();
  const workstreamId = workstreamIdArg ?? workstreamIdQueryParam;
  assertIsDefined(workstreamId, 'workstreamId');

  const workstream = useOrganizationWorkstream(workstreamId).data;
  const orgMilestones = useOrganizationRoadmapNodes().data;

  const roadmap = getRoadmapFromWorkstream(workstream);

  const milestonesWithSteps = roadmap?.children?.map((milestone) => {
    return {
      ...milestone,
      children: orgMilestones.filter((orgMs) => orgMs.parent === milestone.id),
    };
  });

  return {
    ...workstream,
    roadmap_nodes: [
      {
        ...roadmap,
        children: milestonesWithSteps,
      },
    ],
  } as Workstream;
};
